export const getMapBounds = (map, maps, places) => {
  const bounds = new maps.LatLngBounds()
  places.forEach((place) => {
    bounds.extend(new maps.LatLng(place.lat, place.lng))
  })
  return bounds
}

export const generatePinLocations = (clinics) => {
  return clinics.map((clinic) => {
    return {
      lat: clinic.lat,
      lng: clinic.lng,
      name: clinic.formatted_name,
      address: [
        clinic.address_1,
        clinic.address_2 || '',
        clinic.city,
        clinic.state,
      ]
        .filter(String)
        .join(', '),
      clinicId: clinic.id,
    }
  })
}

export const setInitialMapCenter = (pinLocations, selectedCardIndex = 0) => {
  if (pinLocations.length === 0) return { lat: 0, lng: 0 }

  try {
    return {
      lat: parseFloat(pinLocations[selectedCardIndex].lat),
      lng: parseFloat(pinLocations[selectedCardIndex].lng),
    }
  } catch {
    return {
      lat: parseFloat(pinLocations[0].lat),
      lng: parseFloat(pinLocations[0].lng),
    }
  }
}
